import React from "react";
import { Text } from "components/fields";


const MinMax = ({ form, isSubscription }) => {

	if(isSubscription) {
		return null;
	} else {
		return <div className="d-flex w-100">
			<Text
				label="Minimum quantity"
				disabled={form.values.licensing_enabled ? "disabled" : ""}
				noteUnder
				wrapperClassName="w-50 pr-3 wm-100"
				type="number"
				placeholder="Example: 1"
				note="If higher than zero, customers will be forced to buy at least this amount of your product."
				name="quantity_min"
				{...form}
				nowrap
			/>
			<Text
				label="Maximum quantity"
				disabled={form.values.licensing_enabled ? "disabled" : ""}
				noteUnder
				wrapperClassName="w-50 wm-100"
				type="number"
				placeholder="Example: 99"
				note="If higher than zero, customers won’t be able to buy more than this amount of your product."
				name="quantity_max"
				{...form}
				nowrap
			/>
		</div>
	}
};

export default MinMax;
